import $ from 'jquery';

$(document).ready(function() {
	$('#element').tooltip('show');
	
});